import { generateAddress } from "../../ExperimentSearch/ExperimentSearchUtil.js";
import FlightSearchContants from "../models/FlightSearchConstants.js";
class FlightSearchActions {
  setFlightSearchContext(flightsearchContext) {
    return {
      type: FlightSearchContants.SET_FLIGHT_SEARCH_CONTEXT,
      payload: flightsearchContext
    };
  }
  setPartialFlightSearchContext(flightsearchPartialContext) {
    return {
      type: FlightSearchContants.SET_PARTIAL_FLIGHT_SEARCH_CONTEXT,
      payload: flightsearchPartialContext
    };
  }
  getFlights(searchQuery, fromDate, toDate, workspaceId, managementGroup) {
    const address = generateAddress({
      searchQuery,
      fromDate,
      toDate,
      workspaceId,
      managementGroup,
      isolationGroup: "All",
      trafficFilters: ""
    });
    return {
      type: FlightSearchContants.FETCH_FLIGHT_RESULTS,
      payload: address,
      workspaceId,
      managementGroup,
      searchQuery,
      fromDate,
      toDate
    };
  }
  getFlightsComplete(result, error) {
    return {
      type: FlightSearchContants.FETCH_FLIGHT_RESULTS_COMPLETE,
      payload: result,
      error
    };
  }
}
const FlightSearchActions$1 = new FlightSearchActions();
export {
  FlightSearchActions,
  FlightSearchActions$1 as default
};
//# sourceMappingURL=FlightSearchActions.js.map
